import { fabric } from "fabric";
import { v4 } from "uuid";
import { CanvasHandler } from "../../handlers";
import { FabricEvent, FabricObject } from "../../types/FabricCustomType";
import { IObjectDesingner } from "../../types/HandlerObjectType";
import { ZoneProperties } from "./properties";
import store from "../../redux/store";
import {
  setZoneActive
} from "../../redux/designerPropertiesSlice";

class PolygonZone extends ZoneProperties implements IObjectDesingner {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
  }
  onRotated(event: FabricEvent) {
    throw new Error("Method not implemented.");
  }

  public onMouseDblClick(event: FabricEvent<Event>) {
    const { target } = event;
    const {
      properties: { zoneActive },
    } = store.getState();
    if (zoneActive) return;
    this.canvasHandler.activeZone = target;
    const objs = this.canvasHandler.canvas.getObjects().filter((obj: any) => obj.id !== this.canvasHandler.activeZone.id);
    const mapRows = this.canvasHandler.canvas.getObjects("group").filter((obj: any) => obj.superType === "row");
    if (mapRows.length > 0) {
      mapRows.forEach((mapRow: any) => {
        const rowSeats = mapRow.getObjects("group");
        rowSeats.forEach((seat: any) => {
          seat.set({
            selectable: false
          })
        });
      })
    }
    objs.map((obj: any) => obj.set({ selectable: false, opacity: 0.5 }));
    const shape = target.item(0);
    const text = target.item(1);
    target.set({
      lockMovementX: true,
      lockMovementY: true,
      selectable: false
    });
    shape.set({
      originalFill: shape.fill,
      fill: "#FFFFFF",

    });
    text.set({
      visible: false
    });
    const rows = target.getObjects("group");
    if (rows) {
      rows.forEach((row: any) => {
        row.set({
          visible: true
        })
        this.canvasHandler.canvas.add(row);
        this.canvasHandler.canvas.requestRenderAll();
        target.removeWithUpdate(row);
      });
    }
    this.canvasHandler.onZone(false);
    this.canvasHandler.canvas.requestRenderAll();
    store.dispatch(setZoneActive(true));
    this.canvasHandler.canvas.discardActiveObject();
  }

  public onInit() {
    this.canvasHandler.interactionHandler.drawing("polygonZone");
    this.canvasHandler.pointArray = [];
    this.canvasHandler.lineArray = [];
    this.canvasHandler.activeLine = null;
    this.canvasHandler.activeShape = null;
    this.canvasHandler.activeShapePolygon = null;
  }

  public onMousedown(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    const { target } = event;
    if (
      target &&
      this.canvasHandler.pointArray.length &&
      target.id === this.canvasHandler.pointArray[0].id
    ) {
      this.generate(this.canvasHandler.pointArray);
    } else {
      this.addPoint(x, y);
    }
  }

  public onMousemove(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    if (this.canvasHandler.activeLine && this.canvasHandler.activeLine.class === "line") {
      this.canvasHandler.activeLine.set({ x2: x, y2: y });
      const points = this.canvasHandler.activeShape.get("points");
      points[this.canvasHandler.pointArray.length] = { x, y };
      this.canvasHandler.activeShape.set({ points });
      this.canvasHandler.canvas.requestRenderAll();
    }
  }

  public onMouseup(event: FabricEvent<MouseEvent>) {
    const { x, y } = this.canvasHandler.canvas.getPointer(event.e);
    return;
  }

  private addPoint(x: number, y: number) {
    const circle = new fabric.Circle({
      radius: 3,
      fill: "#cccccc",
      stroke: "#727272",
      strokeWidth: 0.5,
      left: x,
      top: y,
      selectable: false,
      hasBorders: false,
      hasControls: false,
      originX: "center",
      originY: "center",
      hoverCursor: "pointer",
    }) as FabricObject<fabric.Circle>;
    circle.set({ id: v4() });
    if (!this.canvasHandler.pointArray.length) circle.set({ fill: "red" });
    const points = [x, y, x, y];
    const line = new fabric.Line(points, {
      strokeWidth: 4,
      fill: "#cccccc",
      stroke: "#727272",
      originX: "center",
      originY: "center",
      selectable: false,
      hasBorders: false,
      hasControls: false,
      evented: false,
    }) as FabricObject<fabric.Line>;
    line.set({ class: "line" });
    if (this.canvasHandler.activeShape) {
      const activeShapePoints = this.canvasHandler.activeShape.get(
        "points"
      ) as Array<{ x: number; y: number }>;
      activeShapePoints.push({ x, y });
      const polygonZone = new fabric.Polygon(activeShapePoints, {
        stroke: "#727272",
        strokeWidth: 4,
        fill: "#cccccc",
        opacity: 0.1,
        selectable: false,
        hasBorders: false,
        hasControls: false,
        evented: false,
      });
      this.canvasHandler.canvas.remove(this.canvasHandler.activeShape);
      this.canvasHandler.canvas.add(polygonZone);
      this.canvasHandler.activeShape = polygonZone;
      this.canvasHandler.activeShapePolygon = polygonZone;
      this.canvasHandler.canvas.renderAll();
    } else {
      const polyPoint = [{ x, y }];
      const polygonZone = new fabric.Polygon(polyPoint, {
        stroke: "#727272",
        strokeWidth: 4,
        fill: "#cccccc",
        opacity: 0.1,
        selectable: false,
        hasBorders: false,
        hasControls: false,
        evented: false,
      });
      this.canvasHandler.activeShape = polygonZone;
      this.canvasHandler.activeShapePolygon = polygonZone;
      this.canvasHandler.canvas.add(polygonZone);
    }
    this.canvasHandler.activeLine = line;
    this.canvasHandler.pointArray.push(circle);
    this.canvasHandler.lineArray.push(line);
    this.canvasHandler.canvas.add(line);
    this.canvasHandler.canvas.add(circle);
  }

  private generate(pointArray: FabricObject<fabric.Circle>[]) {
    const points = [] as any[];
    const id = v4();
    const { editable } = this.canvasHandler;
    pointArray.forEach((point) => {
      points.push({ x: point.left, y: point.top });
      this.canvasHandler.canvas.remove(point);
    });
    this.canvasHandler.lineArray.forEach((line) => {
      this.canvasHandler.canvas.remove(line);
    });
    this.canvasHandler.canvas
      .remove(this.canvasHandler.activeShape)
      .remove(this.canvasHandler.activeLine);
    this.canvasHandler.activeShape = new fabric.Polygon(points, {
      type: "polygon",
      stroke: "#727272",
      strokeWidth: 3,
      fill: "#cccccc",
      opacity: 1,
      objectCaching: !this.canvasHandler.editable,
      name: "New polygon",
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: false,
      lockMovementY: false,
      hoverCursor: !editable ? "pointer" : "move",
      perPixelTargetFind: true,
    }) as FabricObject<fabric.Polygon>;

    this.canvasHandler.activeShape.set({
      id,
      superType: "drawing",
    });

    this.canvasHandler.objText = new fabric.Text("Label", {
      fontSize: 16,
      left: this.canvasHandler.originPointer.x,
      top: this.canvasHandler.originPointer.y,
      angle: 0,
      fill: "#727272",
      stroke: "#727272",
      strokeWidth: 0,
      fontFamily: "Roboto",
      opacity: 1,
      type: "textbox",
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: !editable,
      lockMovementY: !editable,
      hoverCursor: !editable ? "pointer" : "move",
      text: "?",
    }) as FabricObject<fabric.Text>;

    this.canvasHandler.objText.set({
      id: id,
      superType: "textbox",
      container: this.canvasHandler.container.id,
      editable,
      displayedLabel: false,
      zoneID: this.canvasHandler.activeShape.id
    });

    let group = new fabric.Group(
      [this.canvasHandler.activeShape, this.canvasHandler.objText],
      {
        left: this.canvasHandler.activeShape.left,
        top: this.canvasHandler.activeShape.top,
        hasControls: editable,
        hasBorders: editable,
        selectable: editable,
        type: "group",
        subTargetCheck: true,
      }
    ) as FabricObject<fabric.Group>;
    group.set({
      id: id,
      superType: "polygonZone",
      tooltip: {
        enabled: true,
      },
      category: {
        key: 0,
      },
      section: {
        label: "",
        displayedLabel: "",
      },
    });
    // eliminamos el objeto creado incialmente del canvas
    this.canvasHandler.canvas.add(group);

    //se establecen en 0 la posicion del label en X y Y

    group.item(1).left = 0;
    group.item(1).top = 0;
    group.setControlsVisibility({
      tl: false, //top-left
      mt: false, // middle-top
      tr: false, //top-right
      ml: false, //middle-left
      mr: false, //middle-right
      bl: false, // bottom-left
      mb: false, //middle-bottom
      br: false, //bottom-right
      mtr: false,
    });
    group.set({
      perPixelTargetFind: true
    })
    // se le resta la mitad de la anchura y altura del texto por defecto para centrar el texto con el objeto
    const widthText = group.item(1).width ?? 0;
    const heightText = group.item(1).height ?? 0;
    group.item(1).set({
      left: -(widthText / 2),
      top: -(heightText / 2),
      // fontsize: (group.item(1).width / 4)
    });
    if (!this.canvasHandler.transactionHandler.active) {
      this.canvasHandler.transactionHandler.save("add");
    }
    this.canvasHandler.onAdd(group);

    // let zoneGroup = new fabric.Group(
    //   [group],
    //   {
    //     type: "group",
    //   }
    // ) as FabricObject<fabric.Group>;
    // zoneGroup.set("superType", "zoneGroup")
    // zoneGroup.setControlsVisibility({
    //   tl: false, //top-left
    //   mt: false, // middle-top
    //   tr: false, //top-right
    //   ml: false, //middle-left
    //   mr: false, //middle-right
    //   bl: false, // bottom-left
    //   mb: false, //middle-bottom
    //   br: false, //bottom-right
    //   mtr: false,
    // });

    // this.canvasHandler.canvas.add(zoneGroup);

    this.canvasHandler.pointArray = [];
    this.canvasHandler.activeLine = null;
    this.canvasHandler.activeShape = null;
    // this.canvasHandler.interactionHandler.selection();
  }

  private finish() {
    this.canvasHandler.pointArray.forEach((point) => {
      this.canvasHandler.canvas.remove(point);
    });
    this.canvasHandler.lineArray.forEach((line) => {
      this.canvasHandler.canvas.remove(line);
    });
    this.canvasHandler.canvas.remove(this.canvasHandler.activeLine);
    this.canvasHandler.canvas.remove(this.canvasHandler.activeShape);
    this.canvasHandler.pointArray = [];
    this.canvasHandler.lineArray = [];
    this.canvasHandler.activeLine = null;
    this.canvasHandler.activeShape = null;
    this.canvasHandler.canvas.renderAll();
    this.canvasHandler.interactionHandler.selection();
  }
}
export default PolygonZone;
